/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

/** Unique tabs using H6 as an anchor **/
$($('.product-single__content-text').find('h6').get()).each(function(i) {
    
    var tabName = $(this).text();
    tabContent = '';
    
    //check if h6 has text inside
  if ($(this).text() != '') {
        
        //hide h6
      $(this).hide();
  
        //combine content between H6 elements
        $(this).nextUntil('h6').each(function() {
            tabContent = tabContent + this.outerHTML;
            
            //hide content
            $(this).hide();
        });
    
        //generate tab HTML
        if($('#acc-reviews').length) {
            $('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-accordion-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>').insertBefore('.js-review-accordion');
            $('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-accordion-info"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>').insertBefore('.js-review-accordion');
        } else {
            $('.js-accordion').append('<a href="#acc-unique-'+ [i] +'" class="product-single__accordion__title js-accordion-trigger"><h4 class="product-single__accordion__title-text">' + tabName + '</h4><span class="product-single__accordion__title-icon icon-fallback"><i class="icon icon--plus" aria-hidden="true"></i><span class="icon-fallback__text">Open tab</span></span></a>');
            $('.js-accordion').append('<div id="acc-unique-'+ [i] +'" class="product-single__accordion__item js-accordion-info"><div class="product-single__accordion__item-wrap rte">' + tabContent + '</div></div>');
        }

    } else {  

        //hide empty H6
        $(this).hide();
    }
});

$(document).ready(function() {
    var keyIngredients = $('.js-accordion-trigger[href="#acc-key-ingredients"]');
    if(keyIngredients.length) {
        keyIngredients.click();
    }
});

activeSidebar($(window).scrollTop());

$(window).scroll(function() {
    var window_top = $(this).scrollTop();
    if($('#scroll-top').length) {
        if(window_top > 100) {
            $("#scroll-top").fadeIn(300);
        } else {
            $("#scroll-top").fadeOut(300);
        }
    }

    if($("#shopify-section-page-our-story").length) {
        activeSidebar(window_top);
    }

    if($(".question-links-pos").length && $(window).width() <= 767) {
        questionLinksPos(window_top);
    } else {
        $('.question-links').css('position', 'static');
    }
});

$('#scroll-top').on('click', function() {
    $('body,html').animate({
        scrollTop: 0
    }, 800);
})

$('.js-ingredients-trigger').magnificPopup({
	type: 'inline',
    mainClass: "mfp-medium",
    fixedContentPos: true,
    removalDelay: 200
});

// $("#shopify-section-page-our-story .js-scroll-id").click(function(e) {
//     $('.collection-sidebar__item').removeClass('collection-sidebar__item--active');
//     $(this).parent().addClass('collection-sidebar__item--active');
// });

$(".collection-sidebar__items:not(.home-custom__item) select").change(function() {
    window.location.href = $(this).val();
});

$(".collection-sidebar__items.home-custom__item select").change(function() {
    var thisId = $(this).val();

    //check for the offset
    if ($(".js-header").hasClass("js-header-sticky")) {
      scrollOffset = 118;
    } else {
      scrollOffset = 18;
    }

    //scroll
    $("html,body").animate(
      {
        scrollTop: $(thisId).offset().top - scrollOffset
      },
      800
    );

    return false;
});

if($('.form-success').length) {
    var queryString = window.location.search;
    if(queryString.substring(1) == 'contact_posted=true') {
        //check for the offset
        if ($(".js-header").hasClass("js-header-sticky")) {
          scrollOffset = 118;
        } else {
          scrollOffset = 18;
        }

        //scroll
        $("html,body").animate(
          {
            scrollTop: $('.form-success').offset().top - scrollOffset
          },
          800
        );
    }
}

function activeSidebar(window_top) {
    //check for the offset
    if ($(".js-header").hasClass("js-header-sticky")) {
      scrollOffset = 128;
    } else {
      scrollOffset = 28;
    }

    $("#shopify-section-page-our-story .js-scroll-id").each(function() {
        var id = $(this).attr('href');
        if($(id).length) {
            var id_top = $(id).offset().top - scrollOffset;
            if(window_top > id_top) {
                $('.collection-sidebar__item').removeClass('collection-sidebar__item--active');
                $(this).parent().addClass('collection-sidebar__item--active');
            }
        }
    });
}

function doshaResults(questions) {
    var results = [];
    var counts = {1:0,2:0,3:0};

    $(questions).each(function() {
        var answer = $(this).find('input:checked').val();
        if(answer) {
            results.push(answer);
        }
    });

    $.each(results, function(key,value) {
      if (!counts.hasOwnProperty(value)) {
        counts[value] = 1;
      } else {
        counts[value]++;
      }
    });

    if(counts[1] > counts[2] && counts[1] > counts[3]) {
        var collection = 'vata';
    } else if(counts[2] > counts[1] && counts[2] > counts[3]) {
        var collection = 'pitta';
    } else if(counts[3] > counts[1] && counts[3] > counts[2]) {
        var collection = 'kapha';
    } else if(counts[1] > counts[3] && counts[2] > counts[3] && counts[1] == counts[2]) {
        var collection = 'vata';
    } else if(counts[1] > counts[2] && counts[3] > counts[2] && counts[1] == counts[3]) {
        var collection = 'vata';
    } else if(counts[2] > counts[1] && counts[3] > counts[1] && counts[2] == counts[3]) {
        var collection = 'pitta';
    }

    $('.question-links').attr('data-collection', collection);
    $('.questions-content .question-links .c-btn').hide();
    $('#email_address_0').attr('placeholder','email@example.com');
    $('#custom_field_string_dosha_0').val(collection);
    $('.ctct-form-success').html('<a href="/collections/' + collection + '" class="c-btn c-btn--primary c-btn--arrow js-no-transition">Let\'s See My Dosha</a>');
    $('.ctct-inline-form').show();
  	$('#consent-dosha').val(collection);
    KlaviyoSubscribe.attachToForms('#email_signup', {
     hide_form_on_success: true,
     success_url: "/collections/" + collection
    });
}

function finderResults(questions) {
    var results = {};
    var results_text = {};

    $(questions).each(function() {
        var question = $(this).find('input:checked').attr('name');
        if($(this).hasClass('multiselect')) {
            var answers = $(this).find('input:checked');
            var answer = [];
            var answer_text = [];
            $(answers).each(function() {
                answer.push($(this).val());
                answer_text.push($(this).parent().find('.section__title--desc h5').text());
            });
        } else {
            var answer = $(this).find('input:checked').val();
            var answer_text = $(this).find('input:checked').parent().find('.section__title--desc h5').text();
        }

        if(answer) {
            results[question] = answer;
            results_text[question] = answer_text;
        }
    });

    // DRY / DEHYDRATED
    if(results['question-1'] == 1) {
        // YES
        if(results['question-2'] == 1) {
            // 20s, 30s
            if(results['question-5'] == 1 || results['question-5'] == 2) {
                var skin_care = ['comfrey-cleanser','essential-dry-skin','neem-tamanu-corrective-moisturizer','neem-night-cream'];
            // 40s, 50s
            } else if(results['question-5'] == 3 || results['question-5'] == 4) {
                var skin_care = ['neem-copper-repairing-cream-cleanser','essential-dry-skin','neem-tamanu-corrective-moisturizer','neem-night-cream'];
            // 60s
            } else if(results['question-5'] == 5) {
                var skin_care = ['neem-copper-repairing-cream-cleanser','essential-dry-skin','neem-tamanu-corrective-moisturizer','neem-night-cream'];
            // No Response
            } else {
                var skin_care = ['neem-copper-repairing-cream-cleanser','essential-dry-skin','neem-tamanu-corrective-moisturizer','neem-night-cream'];
            }
        // NO
        } else {
            // 20s, 30s
            if(results['question-5'] == 1 || results['question-5'] == 2) {
                var skin_care = ['comfrey-cleanser','essential-dry-skin','lavender-moisturizer','omega3-amalaki-night-cream'];
            // 40s, 50s
            } else if(results['question-5'] == 3 || results['question-5'] == 4) {
                var skin_care = ['gentle-gel-cleanser','essential-dry-skin','omega3-amalaki-night-cream','neem-night-cream'];
            // 60s
            } else if(results['question-5'] == 5) {
                var skin_care = ['omega3-white-birch-cream-cleanser','essential-dry-skin','omega3-amalaki-night-cream','neem-night-cream'];
            // No Response
            } else {
                var skin_care = ['gentle-gel-cleanser','essential-dry-skin','omega3-amalaki-night-cream','neem-night-cream'];
            }
        }

        // BODYCARE
        if(results['question-4'] == 1) {
            var body_care = ['omega3-rose-hip-body-cleanser','omega3-soybean-softening-body-baume','omega3-loquat-softening-body-milk'];
        }
    // OILY / SHINY
    } else if(results['question-1'] == 2) {
        // YES
        if(results['question-2'] == 1) {
            // 20s, 30s, 40s
            if(results['question-5'] == 1 || results['question-5'] == 2 || results['question-5'] == 3) {
                var skin_care = ['neem-burdock-balancing-cream-gel-cleanser','essential-oil-oily-skin','cornflower-oil-free-hydrator','neem-night-cream'];
            // 50s, 60s
            } else if(results['question-5'] == 4 || results['question-5'] == 5) {
                var skin_care = ['neem-burdock-balancing-cream-gel-cleanser','essential-oil-oily-skin','neem-avocado-balancing-moisturizer','neem-night-cream'];
            // No Response
            } else {
                var skin_care = ['neem-burdock-balancing-cream-gel-cleanser','essential-oil-oily-skin','cornflower-oil-free-hydrator','neem-night-cream'];
            }
        // NO
        } else {
            // 20s, 30s, 40s
            if(results['question-5'] == 1 || results['question-5'] == 2 || results['question-5'] == 3) {
                var skin_care = ['lemon-cleanser','essential-oil-oily-skin','cornflower-oil-free-hydrator','neem-night-cream'];
            // 50s, 60s
            } else if(results['question-5'] == 4 || results['question-5'] == 5) {
                var skin_care = ['lemon-cleanser','essential-oil-oily-skin','neem-avocado-balancing-moisturizer','neem-night-cream'];
            // No Response
            } else {
                var skin_care = ['lemon-cleanser','essential-oil-oily-skin','cornflower-oil-free-hydrator','neem-night-cream'];
            }
        }

        // BODYCARE
        if(results['question-4'] == 1) {
            var body_care = ['gotu-kola-carrageenan-body-cleanser','gotu-kola-lotus-body-oil','gotu-kola-kukui-body-lotion'];
        }
    // DRY / OILY T ZONE
    } else if(results['question-1'] == 3) {
        // YES
        if(results['question-2'] == 1) {
            // 20s, 30s, 40s
            if(results['question-5'] == 1 || results['question-5'] == 2 || results['question-5'] == 3) {
                var skin_care = ['neem-burdock-balancing-cream-gel-cleanser','essential-oil-normal-comb-skin','neem-avocado-balancing-moisturizer','neem-night-cream'];
            // 50s, 60s
            } else if(results['question-5'] == 4 || results['question-5'] == 5) {
                var skin_care = ['neem-copper-repairing-cream-cleanser','essential-oil-normal-comb-skin','neem-avocado-balancing-moisturizer','neem-night-cream'];
            // No Response
            } else {
                var skin_care = ['neem-copper-repairing-cream-cleanser','essential-oil-normal-comb-skin','neem-avocado-balancing-moisturizer','neem-night-cream'];
            }
        // NO
        } else {
            // 20s, 30s, 40s
            if(results['question-5'] == 1 || results['question-5'] == 2 || results['question-5'] == 3) {
                var skin_care = ['sandalwood-cleanser','essential-oil-normal-comb-skin','elder-flower-moisturizer','neem-night-cream'];
            // 50s, 60s
            } else if(results['question-5'] == 4 || results['question-5'] == 5) {
                var skin_care = ['neem-copper-repairing-cream-cleanser','essential-oil-normal-comb-skin','neem-avocado-balancing-moisturizer','neem-night-cream'];
            // No Response
            } else {
                var skin_care = ['neem-copper-repairing-cream-cleanser','essential-oil-normal-comb-skin','neem-avocado-balancing-moisturizer','neem-night-cream'];
            }
        }

        // BODYCARE
        if(results['question-4'] == 1) {
            var body_care = ['neem-manuka-body-cleanser','neem-triphala-body-oil','neem-blood-orange-body-lotion'];
        }
    // NOT SURE
    } else if(results['question-1'] == 4) {
        // YES
        if(results['question-2'] == 1) {
            // 20s, 30s, 40s
            if(results['question-5'] == 1 || results['question-5'] == 2 || results['question-5'] == 3) {
                var skin_care = ['neem-burdock-balancing-cream-gel-cleanser','essential-oil-normal-comb-skin','neem-avocado-balancing-moisturizer','neem-night-cream'];
            // 50s, 60s
            } else if(results['question-5'] == 4 || results['question-5'] == 5) {
                var skin_care = ['neem-burdock-balancing-cream-gel-cleanser','essential-dry-skin','neem-tamanu-corrective-moisturizer','neem-night-cream'];
            // No Response
            } else {
                var skin_care = ['neem-burdock-balancing-cream-gel-cleanser','essential-dry-skin','neem-tamanu-corrective-moisturizer','neem-night-cream'];
            }

            // BODYCARE
            if(results['question-4'] == 1) {
                var body_care = ['neem-manuka-body-cleanser','neem-triphala-body-oil','neem-blood-orange-body-lotion'];
            }
        // NO
        } else {
            // 20s, 30s, 40s
            if(results['question-5'] == 1 || results['question-5'] == 2 || results['question-5'] == 3) {
                var skin_care = ['gentle-gel-cleanser','essential-oil-normal-comb-skin','neem-avocado-balancing-moisturizer','neem-night-cream'];
            // 50s, 60s
            } else if(results['question-5'] == 4 || results['question-5'] == 5) {
                var skin_care = ['gentle-gel-cleanser','essential-dry-skin','neem-tamanu-corrective-moisturizer','neem-night-cream'];
            // No Response
            } else {
                var skin_care = ['gentle-gel-cleanser','essential-oil-normal-comb-skin','neem-avocado-balancing-moisturizer','neem-night-cream'];
            }

            // BODYCARE
            if(results['question-4'] == 1) {
                var body_care = ['gotu-kola-carrageenan-body-cleanser','gotu-kola-lotus-body-oil','gotu-kola-kukui-body-lotion'];
            }
        }
    }

    // TOP CONCERNS
    var top_concerns = [];
    $.each(results['question-3'], function( index, value ) {
        if(value == 1) {
            top_concerns.push('honey-enzyme-exfoliating-serum');
        } else if(value == 2) {
            top_concerns.push('gotu-kola-yucca-facial-serum');
        } else if(value == 3) {
            top_concerns.push('nighttime-nourishing-oil');
        } else if(value == 4) {
            top_concerns.push('brightening-glow-turmeric-cream');
        } else if(value == 5) {
            top_concerns.push('neem-eye-cream');
        } else if(value == 6) {
            top_concerns.push('t-zone-oil-control-treatment');
        } else if(value == 7) {
            top_concerns.push('neem-green-tea-cleansing-mask');
        } else if(value == 8) {
            top_concerns.push('gotu-kola-boswellia-eye-serum');
        } else if(value == 9) {
            top_concerns.push('chamomile-eye-oil');
        }
    });

    // Display Results in results box
    $('.results__data .skin_care span').text(results_text['question-1']);
    $('.results__data .top_concerns span').text(results_text['question-3'].join(', '));
    $('.results__data .body_care span').text(results_text['question-4']);

    $('.questions-content').hide();
    $('.results-content').show();

    // Display product results
    var products = [skin_care,body_care,top_concerns];
    var sections = ["skin_care","body_care","top_concerns"];

    // Cycle through all categories
    var layout_skin_care = [];
    var layout_skin_care_count = 0;
    var layout_body_care = [];
    var layout_body_care_count = 0;
    var layout_top_concerns = [];
    var layout_top_concerns_count = 0;

    if (products[0] !== undefined && products[0].length != 0) {
        var section_skin_care = '.results__' + sections[0];
        $(section_skin_care).show();

        $.each(products[0], function(key,value) {
            $.ajax({
                url:    "/products/" + value + "?view=json",
                type:   'GET'
            })
            .done(function(data) {
                layout_skin_care[key] = data;
                layout_skin_care_count++;
                if(layout_skin_care_count == products[0].length) {
                    $(section_skin_care).find('.o-layout').append(layout_skin_care.join(''));
                    theme.animScroll();
                }
            })
            .fail(function(data) {})
            .always(function(data) {});
        });
    }

    if (products[1] !== undefined && products[1].length != 0) {
        var section_body_care = '.results__' + sections[1];
        $(section_body_care).show();

        $.each(products[1], function(key,value) {
            $.ajax({
                url:    "/products/" + value + "?view=json",
                type:   'GET'
            })
            .done(function(data) {
                layout_body_care[key] = data;
                layout_body_care_count++;
                if(layout_body_care_count == products[1].length) {
                    $(section_body_care).find('.o-layout').append(layout_body_care.join(''));
                    theme.animScroll();
                }
            })
            .fail(function(data) {})
            .always(function(data) {});
        });
    }

    if (products[2] !== undefined && products[2].length != 0) {
        var section_top_concerns = '.results__' + sections[2];
        $(section_top_concerns).show();

        $.each(products[2], function(key,value) {
            $.ajax({
                url:    "/products/" + value + "?view=json",
                type:   'GET'
            })
            .done(function(data) {
                layout_top_concerns[key] = data;
                layout_top_concerns_count++;
                if(layout_top_concerns_count == products[2].length) {
                    $(section_top_concerns).find('.o-layout').append(layout_top_concerns.join(''));
                    theme.animScroll();
                }
            })
            .fail(function(data) {})
            .always(function(data) {});
        });
    }

    // $.each(products, function(key,value) {
    //     if (products[key] !== undefined && products[key].length != 0) {
    //         var section = '.results__' + sections[key];
    //         $(section).show();
    //     }

    //     $.each(products[key], function(key,value) {
    //         loadProduct(section,value);
    //     });
    // });
}

// function loadProduct(section,handle) {
//     $.ajax({
//         url:    "/products/" + handle + "?view=json",
//         type:   'GET'
//     })
//     .done(function(data) {
//         $(section).find('.o-layout').append(data);
//         theme.animScroll();
//     })
//     .fail(function(data) {})
//     .always(function(data) {});
// };

function questionLinksPos(window_top) {
    var questionLinksBottom = $('.question-links-pos').offset().top + $('.question-links').outerHeight() - $(window).height();
    if(window_top > questionLinksBottom) {
        $('.question-links').css('position', 'absolute');
    } else {
        $('.question-links').css('position', 'fixed');
    }
}

$(".questions-image-text .c-btn").click(function(e) {
    $('.questions-image-text').hide();
    $('.questions-content').show();
    if($(window).width() <= 767) {
        questionLinksPos($(window).scrollTop());
    }
    return false;
});

$(".question.multiselect label").click(function(e) {
    if($('.question.multiselect.active input:checked').length > 3) {
        $.magnificPopup.open({
            items: {
                src: '<div class="search-draw js-search-draw"><div class="search-draw__wrapper"><div class="search__inner questions__inner">Please limit to 3 selections</div>',
                type: 'inline'
            },
            mainClass: "mfp-medium",
            fixedContentPos: true,
            removalDelay: 200
        });
        return false;
    }
});

$(".question label input").change(function(e) {
    var question = $(this).parents('.question');
    if(question.hasClass('multiselect')) {
        $(this).parent().toggleClass('active');
    } else {
        question.find('label.active').removeClass('active');
        $(this).parent().addClass('active');
    }
});

$(".question-links .c-btn").click(function(e) {
    var questions = $('.question');
    var current_question = $('.question.active');
    var pagination = $('.pagination span');

    if($(this).hasClass('c-btn--prev')) {
        var next_question = current_question.prev('.question');
    } else {
        var answer = current_question.find('input:checked').val();
        if(answer || current_question.hasClass('optional')) {
            if(current_question.hasClass('multiselect') && current_question.find('input:checked').length < 2) {
                $.magnificPopup.open({
                    items: {
                        src: '<div class="search-draw js-search-draw"><div class="search-draw__wrapper"><div class="search__inner questions__inner">Please make at least 2 selections</div>',
                        type: 'inline'
                    },
                    mainClass: "mfp-medium",
                    fixedContentPos: true,
                    removalDelay: 200
                });
            } else {
                var next_question = current_question.next('.question');
                if(current_question.hasClass('last')) {
                    if($('.section--page-finder-questions').length) {
                        finderResults(questions);
                    } else {
                        doshaResults(questions);
                    }

                    //scroll
                    $("html,body").animate({
                        scrollTop: 0
                    }, 800);
                }
            }
        } else {
            $.magnificPopup.open({
                items: {
                    src: '<div class="search-draw js-search-draw"><div class="search-draw__wrapper"><div class="search__inner questions__inner">Please make a selection</div>',
                    type: 'inline'
                },
                mainClass: "mfp-medium",
                fixedContentPos: true,
                removalDelay: 200
            });
        }
    }

    if(next_question && next_question.length) {
        //scroll
        $("html,body").animate({
            scrollTop: 0
        }, 800);

        // UPDATE QUESTION
        current_question.removeClass('active');
        next_question.addClass('active');

        // UPDATE PAGINATION
        pagination.removeClass('active');
        pagination.eq(next_question.index()).addClass('active');
    }

    return false;
});

$('.js-modal-btn-youtube').modalVideo();
$('.js-modal-btn-vimeo').modalVideo({channel:'vimeo'});
$(document).ready(function(){
                  KlaviyoSubscribe.attachToForms('#email_signup_footer', {
                  hide_form_on_success: true,
                  extra_properties: {

                  $method_type: "Klaviyo Form footer",
                  $method_id: 'embed',
                  $consent_version: 'Embed default text'
                  }
                  });
});    